import { Box, Paper, Typography, Stack } from "@mui/material";
import { useAuth } from "@/store/auth";
import { PageHeader } from "@/components/PageHeader";
import { StatCard } from "@/components/StatCard";
import { formatLongDate } from "@/shared/datetime";

export function DashboardPage() {
  const user = useAuth(s => s.user);
  const today = formatLongDate(new Date());

  return (
    <Box>
      <PageHeader
        title={`Welcome back, ${user?.fullName?.split(" ")[0] ?? "User"}`}
        subtitle={`${user?.roleName ?? ""} · ${today}`}
      />

      <Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap sx={{ mb: 4 }}>
        <StatCard label="Items in catalog" value="—" hint="Wired up; data pending" />
        <StatCard label="Open POs" value="—" severity="info" />
        <StatCard label="Today's invoices" value="—" severity="success" />
        <StatCard label="Low-stock alerts" value="—" severity="warning" />
      </Stack>

      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>Getting started</Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Once seed data flows through the API, KPI tiles will populate from the backend reports endpoints.
          Use the navigation sidebar to access catalog, inventory, procurement, and sales modules.
        </Typography>
        <Typography variant="body2" color="text.secondary">Suggested next steps:</Typography>
        <Box component="ul" sx={{ mt: 1, mb: 0, color: "text.secondary", "& li": { mb: 0.5 } }}>
          <li>Set up items, vendors, and customers in <strong>Catalog</strong></li>
          <li>Create your first PO → GRN → PI flow in <strong>Procurement</strong></li>
          <li>Issue an OP invoice in <strong>Sales</strong> and observe ledger ISSUE entries</li>
        </Box>
      </Paper>
    </Box>
  );
}
